import { Box, InputLabel, Stack, Typography } from '@mui/material';
import React from 'react';
import FormCounter from '../../../../shared/FormCounter';

export default function NewActivityAmenitiesForm() {
    return (
        <fieldset>
            <Stack spacing={2}>
                <div>
                    <Typography variant='h2' component='legend'>
                        Experience Amenities
                    </Typography>
                    <Typography color='text.secondary' gutterBottom>
                        Tell guests what your activity has to offer
                    </Typography>
                </div>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel htmlFor='quantity__input'>
                        No. Available
                    </InputLabel>
                    <FormCounter
                        id='quantity__input'
                        name='details.quantity'
                        max={20}
                        disabled={false}
                    />
                </Box>
            </Stack>
        </fieldset>
    );
}
